export const STORAGE_KEYS = {
  SECTIONS_ORDER: 'enhancementsReport_sectionsOrder',
  HIDDEN_SECTIONS: 'enhancementsReport_hiddenSections',
} as const

export const SECTION_IDS = {
  OVERVIEW_TILES: 'overview-tiles',
  BY_TYPE_BY_MONTH: 'by-type-by-month',
  TOP20_ONCALL_HOURS: 'top20-onCall-hours',
  TOP20_CALLOUT_HOURS: 'top20-callOut-hours',
  TOP20_PRODUCTS: 'top20-products',
  HOURS_VS_CALLOUT_RATIO: 'hours-vs-callout-ratio',
  SUBMITTED_VS_OVERWRITTEN: 'submitted-vs-overwritten',
  ONTIME_SUBMISSION: 'onTime-submission',
} as const
